import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./_shared/shared.module";
import { DashboardModule } from "./_features/dashboard/dashboard.module";
import { CoreModule } from "src/app/_core/core.module";
import { FormsModule } from "@angular/forms";
import { HttpClientModule} from "@angular/common/http";
import { AngularEditorModule } from "@kolkov/angular-editor";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    HttpClientModule,
    AngularEditorModule,
    FormsModule,
    DashboardModule
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
